import React, { useEffect, useRef } from "react";
import "../styles/Summernote.css"

interface SummernoteEditorProps {
  value: string;
  onChange: (content: string) => void;
}

const SummernoteEditor: React.FC<SummernoteEditorProps> = ({ value, onChange }) => {
  const editorRef = useRef<HTMLDivElement | null>(null);

useEffect(() => {
  if (editorRef.current) {
    // @ts-ignore
// Dans SummernoteEditor.tsx
    $(editorRef.current).summernote({
      placeholder: "Écrivez votre message ici...",
      tabsize: 2,
      height: 250,
      toolbar: [
        ["style", ["bold", "italic", "underline", "clear"]],
        ["font", ["strikethrough", "superscript", "subscript"]],
        ["fontsize", ["fontsize"]],
        ["color", ["color"]],
        ["para", ["ul", "ol", "paragraph"]],
        ["insert", ["link"]], // ← Ajouter cette ligne pour les liens et images
      ],
      callbacks: {
        onChange: function (contents: string) {
          onChange(contents);
        },
      },
    });
    // Initialisation avec la valeur actuelle
    // @ts-ignore
    $(editorRef.current).summernote("code", value);
  }

  return () => {
    if (editorRef.current) {
      // @ts-ignore
      $(editorRef.current).summernote("destroy");
    }
  };
}, []);

useEffect(() => {
  if (editorRef.current) {
    // @ts-ignore
    const currentContent = $(editorRef.current).summernote("code");
    if (currentContent !== value) {
      // @ts-ignore
      $(editorRef.current).summernote("code", value);
    }
  }
}, [value]);



  return <div ref={editorRef} />;
};

export default SummernoteEditor;
